var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailSending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFA2A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6377 17.9421L11.9885 11.066C11.8737 11.0121 11.7447 10.9905 11.6172 11.0038C11.4896 11.0171 11.3688 11.0648 11.2694 11.141C11.1744 11.2157 11.1036 11.3138 11.0648 11.4242C11.0259 11.5347 11.0207 11.6531 11.0496 11.7661L13.0206 18.4984L11.023 25.212C10.9959 25.3064 10.9927 25.4055 11.0138 25.5013C11.0348 25.5971 11.0795 25.6869 11.1443 25.7635C11.2091 25.8401 11.2921 25.9014 11.3867 25.9424C11.4812 25.9834 11.5848 26.003 11.6889 25.9996C11.7931 25.999 11.8958 25.9755 11.9885 25.9309L26.6377 19.0548C26.7468 19.0023 26.8383 18.9226 26.9023 18.8245C26.9662 18.7263 27 18.6135 27 18.4984C27 18.3834 26.9662 18.2706 26.9023 18.1724C26.8383 18.0743 26.7468 17.9946 26.6377 17.9421ZM12.721 24.1931L14.1926 19.1235H20.3452V17.8733H14.1926L12.721 12.8038L24.8465 18.4984L12.721 24.1931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailSending);
export default __webpack_public_path__ + "static/media/icon-email-sending.45ad9c0306bd4a685ff85c5684cb2a1a.svg";
export { ForwardRef as ReactComponent };